module.exports = __webpack_public_path__ + "LS.8d72ba2d.json";